import axios from './../plugins/private-api-axios'
import toast from './../plugins/izitoast'

export const fleetService = {
    urlPrefix: '/vehicleFleets',
    config: {
        headers: {
            Authorization: ''
        }
    },
    async getFleetList (page, perPage, name = null, parentId = null, registrationNumber = null) {
        let urlBuilder = {
            'skip': (page - 1) * perPage,
            'take': perPage
        }

        if (null !== name) {
            urlBuilder.name = `%${name}%`
        }

        if (null !== parentId) {
            urlBuilder.ParentFleetId = parentId
        }

        if (null !== registrationNumber) {
            urlBuilder.NameOrRegistrationNumber = registrationNumber
        }

        try {
            return await axios.get(`${this.urlPrefix}?${new URLSearchParams(urlBuilder).toString()}`, this.config)
        } catch (e) {
            toast.error('Cannot receive fleets, please try again later.')
            throw e
        }
    },
    async getFleetByUuid (uuid) {
        try {
            return await axios.get(`${this.urlPrefix}/${uuid}`, this.config)
        } catch (e) {
            toast.error(e.message)
            throw e
        }
    },
    async createFleet (name, parentFleetId) {
        try {
            return await axios.post(this.urlPrefix, {
                name: name,
                parentFleetId: parentFleetId
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async deleteFleet (uuid) {
        try {
            return await axios.delete(`${this.urlPrefix}/${uuid}`, this.config)
        } catch (e) {
            toast.error(e.message)
            throw e
        }
    },
    async editFleet (uuid, name, parentFleetId) {
        try {
            return await axios.put(`${this.urlPrefix}/${uuid}`, {
                name: name,
                parentFleetId: parentFleetId
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async getVehiclesEventsSummary () {
        try {
            return await axios.get(`${this.urlPrefix}/getAllVehiclesFleetsSummary`, this.config)
        } catch (e) {
            toast.error(e.message)
            throw e
        }
    }
}

export const updateFleetService = (accessToken) => {
    fleetService.config.headers.Authorization = accessToken
}

export default fleetService
